import { useEffect } from "react";
import { GameVisuals } from "../../../gql/graphql";
import { CharStatuses } from "../statuses";
import { Key } from "./Key";

import styles from "./Keyboard.module.scss";

const DELETE_TEXT = "Delete";
const ENTER_TEXT = "Enter";

type Props = {
  onChar: (value: string) => void;
  onDelete: () => void;
  onEnter: () => void;
  statuses: CharStatuses;
  theme: GameVisuals;
};

export const Keyboard = ({ onChar, onDelete, onEnter, statuses, theme }: Props) => {
  const onClick = (value: string) => {
    if (value === "ENTER") {
      onEnter();
    } else if (value === "DELETE") {
      onDelete();
    } else {
      onChar(value);
    }
  };

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (e.code === "Enter") {
        onEnter();
      } else if (e.code === "Backspace") {
        onDelete();
      } else {
        const key = e.key.toUpperCase();
        if (key.length === 1 && key >= "A" && key <= "Z") {
          onChar(key);
        }
      }
    };
    window.addEventListener("keyup", listener);
    return () => {
      window.removeEventListener("keyup", listener);
    };
  }, [onEnter, onDelete, onChar]);

  return (
    <div>
      <div className={styles.row}>
        {["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"].map((key) => (
          <Key value={key} key={key} onClick={onClick} status={statuses[key]} theme={theme} />
        ))}
      </div>
      <div className={styles.row}>
        {["A", "S", "D", "F", "G", "H", "J", "K", "L"].map((key) => (
          <Key value={key} key={key} onClick={onClick} status={statuses[key]} theme={theme} />
        ))}
      </div>
      <div className={styles.row}>
        <Key value="ENTER" onClick={onClick} theme={theme}>
          {ENTER_TEXT}
        </Key>
        {["Z", "X", "C", "V", "B", "N", "M"].map((key) => (
          <Key value={key} key={key} onClick={onClick} status={statuses[key]} theme={theme} />
        ))}
        <Key value="DELETE" onClick={onClick} theme={theme}>
          {DELETE_TEXT}
        </Key>
      </div>
    </div>
  );
};
